<div class="promotion-detail-modal">
  <div class="promotion-detail-modal__handle-wrap">
    <button
      type="button"
      class="promotion-detail-modal__handle"
      (click)="onDismiss()"
      [attr.aria-label]="'MODAL.CLOSE_ARIA_LABEL' | translate"
    ></button>
  </div>

  <div class="promotion-detail-modal__header">
    <div class="promotion-detail-modal__header-text">
      @if (headline.hasStructuredHeadline) {
        <p class="promotion-detail-modal__headline">
          <span>{{ headline.headlineLead }}</span>
          <span>{{ "LANDING.PROMOTIONS.PRICE_FROM" | translate }}</span>
          <span class="promotion-detail-modal__price--old">{{
            headline.oldPriceLabel
          }}</span>
          <span>{{ "LANDING.PROMOTIONS.PRICE_TO" | translate }}</span>
          <span class="promotion-detail-modal__price--new">{{
            headline.newPriceLabel
          }}</span>
        </p>
      } @else {
        <p class="promotion-detail-modal__headline">
          {{ headline.fallbackTitle }}
        </p>
      }
    </div>

    <button
      type="button"
      class="promotion-detail-modal__close"
      (click)="onDismiss()"
      [attr.aria-label]="'MODAL.CLOSE_ARIA_LABEL' | translate"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div class="promotion-detail-modal__scroll">
    <div class="promotion-detail-modal__body">
      <img
        class="promotion-detail-modal__banner"
        [src]="bannerSrc"
        [alt]="bannerAlt"
        loading="lazy"
      />

      <div class="promotion-detail-modal__chips">
        @if (chips.branchLabel) {
          <div class="promotion-detail-modal__chip">
            <img
              class="promotion-detail-modal__chip-logo"
              src="./assets/img/isotipo.svg"
              alt=""
              width="16"
              height="16"
              aria-hidden="true"
            />
            <span class="promotion-detail-modal__chip-text">{{
              chips.branchLabel
            }}</span>
          </div>
        }

        @if (chips.showAppliesTo) {
          <div class="promotion-detail-modal__chip">
            <mat-icon
              class="promotion-detail-modal__chip-icon"
              svgIcon="payments"
            ></mat-icon>
            <span
              class="promotion-detail-modal__chip-text promotion-detail-modal__chip-text--bold"
            >
              {{ chips.appliesToKey | translate }}
            </span>
          </div>
        }

        @if (chips.showAvailability) {
          <div
            class="promotion-detail-modal__chip promotion-detail-modal__chip--availability"
          >
            <mat-icon
              class="promotion-detail-modal__chip-icon"
              svgIcon="access_time"
            ></mat-icon>
            <span
              class="promotion-detail-modal__chip-text promotion-detail-modal__chip-text--bold"
            >
              {{ chips.availabilityLabel }}
            </span>
          </div>
        }

        @if (chips.showValidity) {
          <div class="promotion-detail-modal__chip">
            <mat-icon
              class="promotion-detail-modal__chip-icon"
              svgIcon="event"
            ></mat-icon>
            <span
              class="promotion-detail-modal__chip-text promotion-detail-modal__chip-text--bold"
            >
              {{ chips.validityLabel }}
            </span>
          </div>
        }

        @if (chips.showDiscount) {
          <div class="promotion-detail-modal__chip">
            <mat-icon
              class="promotion-detail-modal__chip-icon"
              svgIcon="local_offer"
            ></mat-icon>
            <span
              class="promotion-detail-modal__chip-text promotion-detail-modal__chip-text--bold"
            >
              {{ chips.discountLabel }}
            </span>
          </div>
        }
      </div>

      @if (promotion.description) {
        <div
          class="promotion-detail-modal__description"
          [innerHTML]="promotion.description | safeHtml"
        ></div>
      }

      <app-promo-branch-panel
        [branch]="promotion.branch"
      ></app-promo-branch-panel>
    </div>
  </div>

  <div class="promotion-detail-modal__footer">
    <div class="promotion-detail-modal__footer-actions">
      @if (branchPhone) {
        <a
          class="promotion-detail-modal__contact"
          [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_PHONE' | translate"
          [href]="'tel:' + branchPhone"
        >
          <mat-icon svgIcon="call"></mat-icon>
        </a>
      }

      @if (branchWhatsapp) {
        <a
          class="promotion-detail-modal__contact"
          [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_WHATSAPP' | translate"
          target="_blank"
          rel="noopener noreferrer"
          [href]="'https://wa.me/' + branchWhatsapp"
        >
          <i
            class="fa-brands fa-whatsapp promotion-detail-modal__whatsapp"
            aria-hidden="true"
          ></i>
        </a>
      }

      @if (mapsUrl) {
        <a
          class="promotion-detail-modal__contact"
          [matTooltip]="'PROFILE_PAGE.TOOLTIP_MAP' | translate"
          target="_blank"
          rel="noopener noreferrer"
          [href]="mapsUrl"
        >
          <mat-icon svgIcon="room"></mat-icon>
        </a>
      }
    </div>

    <button
      type="button"
      class="promotion-detail-modal__reserve"
      (click)="onReserve()"
    >
      <span class="promotion-detail-modal__reserve-label">{{
        "HOME_BRANCHES.RESERVE_BUTTON" | translate
      }}</span>
      <mat-icon svgIcon="payments"></mat-icon>
    </button>
  </div>
</div>
